(function($, document, window, undefined){

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function() {

    var $body = $("body");
    var refreshTimeout;

    $body.on('click', "a[href='#']", function(event) {
        event.preventDefault();
    });

    enableSelect2();
    enableBackToTop();
    enableTooltips();

    switch (app.action) {

        case 'index/index':
            jwplayer.key = app.jwplayer_key;

            getStreamInfo();

            $body.on('click', 'a.play', function() {
                var $a = $(this),
                    $all_a = $("a.player");

                var audioinstance = document.getElementById("audio-instance");
                if (!audioinstance.paused) {
                    audioinstance.pause();
                    // audioinstance.currentTime = 0;
                }
                jwplayer('jwplayer-instance').stop();

                if ($a.data('url').match(/^http/) && !$a.data('url').match(/live.leanstream.co/)) {
                    audioinstance.setAttribute('src', $a.data('url'));
                    audioinstance.play();
                }
                else {
                    var params = {
                        autostart: true,
                        primary: 'flash',
                        width: 0,
                        height: 0
                    };
                    if ($a.data('url').match(/^http/) && !$a.data('url').match(/.m3u8/)) {
                        params.playlist = [{
                            sources: [{
                                file: $a.data('url') + '?type=.flv',
                                type: "flv",
                            }]
                        }];
                    }
                    else {
                        params.file = $a.data('url');
                    }
                    jwplayer('jwplayer-instance').setup(params);
                    jwplayer().setVolume(75);
                }

                $all_a.removeClass('stop').addClass('play');
                $all_a.siblings('span.label').addClass('hidden');
                $a.addClass('stop').removeClass('play');
                $a.siblings('span.label').removeClass('hidden');
            }).on('click', 'a.stop', function() {
                var $a = $(this),
                    $all_a = $("a.player");

                var audioinstance = document.getElementById("audio-instance");
                if (!audioinstance.paused) {
                    audioinstance.pause();
                    // audioinstance.currentTime = 0;
                }
                jwplayer('jwplayer-instance').stop();

                $a.removeClass('stop').addClass('play');
                $a.siblings('span.label').addClass('hidden');
            });

            $('#filter-tag').select2().on('change', function(e) {
                getStreamInfo();
            });
            break;

        case 'streams/index':
            $("#streamlist").tablesorter({
                sortList: [[0,0]],
                sortForce: [[0,0]],
                headers: {
                    2 : { sorter : false },
                    3 : { sorter : false },
                    4 : { sorter : false }
                }
            });
            $('a.remove-stream').on('click', function(e) {
                e.preventDefault();
                var $link = $(this);
                bootbox.confirm("Do you really want to remove this stream?", function(result) {
                    if (result === true) {
                        window.location.href = $link.attr('href');
                    }
                });
            });
            $('div.make-switch').on('switch-change', function (e, data) {
                var $div  = $(e.target),
                    $el   = $(data.el),
                    value = data.value;

                if (value === true) {
                    bootbox.confirm("You are about the turn the stream monitoring ON", function(result) {
                        if (result === true) {
                            $.post('/streams/set-state', { stream_id : $div.data('id'), state : 1 });
                        }
                        else {
                            $div.bootstrapSwitch('setState', false);
                        }
                    });
                }
                else {
                    $.post('/streams/set-state', { stream_id : $div.data('id'), state : 0 });
                }
            });
            break;

        case 'streams/edit':
            $("#add-stream-form").validate(getValidationRules());

            $("#code").on('keydown', function(e) {
                if ($.inArray(e.keyCode, [8, 9, 13, 16, 27, 37, 39, 46, 110, 173, 189, 190]) === -1 && (e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 65 || e.keyCode > 90)) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            $("#tags").select2({
                tags: app.tags
            }).on('change', function(e) {
                // new tag added
                if ($.inArray(e.added, app.tags) === -1) {
                    $.post('/tag/add', { tag : e.added.text }, function(resp) {
                        app.tags = resp;
                    }, 'json');
                }
            });

            $("#volume_alert_to, #outage_alert_to").select2({
                tags: app.alertlists
            });
            break;

        case 'streams/import':
            $(document).on('click', 'button.browse', function(){
                var file = $(this).parent().parent().parent().find('input.file-upload-field');
                file.trigger('click');
            });
            $(document).on('change', 'input.file-upload-field', function(){
                $(this).parent().find('.form-control').val($(this).val().replace(/C:\\fakepath\\/i, ''));
            });
            break;

        case 'alert-lists/index':
            $('a.remove-list').on('click', function(e) {
                e.preventDefault();
                var $link = $(this);
                bootbox.confirm("Do you really want to remove this alert list?", function(result) {
                    if (result === true) {
                        window.location.href = $link.attr('href');
                    }
                });
            });
            $('div.make-switch').on('switch-change', function (e, data) {
                var $div  = $(e.target),
                    $el   = $(data.el),
                    value = data.value;

                $.post('/alert-lists/set-state', { alertlist_id : $div.data('id'), state : ~~value });
            });
            break;

        case 'alert-lists/edit':
            $("#edit-alert-list-form").validate($.extend({
                rules: {
                    name: {
                        required: true,
                    },
                    'destination_value[]': {
                        required: true,
                        email: {
                            depends: function(element) {
                                return $(element).parents('div.destination-div').find('select').find('option:selected').val() === 'email';
                            }
                        },
                        phone: {
                            depends: function(element) {
                                return $(element).parents('div.destination-div').find('select').find('option:selected').val() === 'sms';
                            }
                        }
                    }
                }
            }, getValidationRules()));
            $('body').on('click', 'a.remove-alert-list-destination', function() {
                $(this).closest('div.destination-div').remove();
            });
            $("#add-destination-div").click(function() {
                $("#destinations").append($("#destination-div").html());
                enableSelect2();
            });
            $("#send-test-alert-list").click(function() {
                var $btn = $(this);
                $.post('/alert-lists/send-test', $('#edit-alert-list-form').find('select.destination_type, input.destination_value').serialize(), function(resp) {
                    $btn.after('<p>' + resp.msg + '</p>').siblings('p').delay(3000).fadeOut();
                }, 'json');
            });
            break;

    }

});

function enableSelect2() {
    $('select:visible').select2().on('change', function(e) {
        if (e.target.hasAttribute('required') && e.val !== '') {
            $(e.target).closest('div.form-group').removeClass('has-error').end().siblings('span.help-inline').hide();
        }
    });
}

function enableBackToTop() {
    var backToTop = $('<a>', { id: 'back-to-top', href: '#top' });
    var icon = $('<i>', { class: 'fas fa-chevron-up' });

    backToTop.appendTo ('body');
    icon.appendTo (backToTop);

    backToTop.hide();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 150) {
            backToTop.fadeIn();
        }
        else {
            backToTop.fadeOut();
        }
    });

    backToTop.click (function (e) {
        e.preventDefault ();

        $('body, html').animate({
            scrollTop: 0
        }, 600);
    });
}

function enableTooltips() {
    $('.tip').tooltip();
    $('.tip-left').tooltip({ placement: 'left' });
    $('.tip-right').tooltip({ placement: 'right' });
    $('.tip-top').tooltip({ placement: 'top' });
    $('.tip-bottom').tooltip({ placement: 'bottom' });
}

function getStreamInfo() {
    var $stats = $("#stats"),
        $boxes = $stats.find('div.shortcut'),
        $progress = $("#dashboard-refresh-progress"),
        box_ids = [];

    $.ajax({
        url : '/get-stream-info',
        cache : false,
        data : {
            tag_id : $("#filter-tag").val()
        },
        dataType : 'json'
    }).done(function(streams) {
        if (typeof refreshTimeout !== 'undefined') {
            clearTimeout(refreshTimeout);
        }

        $progress.html('').buildCounter({
            stardate_timestamp : Math.floor(new Date()) / 1000,
            enddate_timestamp  : Math.floor(new Date()) / 1000 + 10,
            color4             : "#d4d4d4",
            backgroundcolor4   : "#ffffff",
            glowwidth4         : 0,
            backgroundwidth4   : "5",
            frontwidth4        : "5",
            size4              : "20",
            layout             : "s"
        });

        for (var station_id in streams) {
            box_ids.push(station_id);

            var $box = $boxes.filter(function() {
                return $(this).data('stream-id') == station_id;
            });
            var $content = $box.find('div.content');

            if (streams[station_id].hidden == true) {
                $box.addClass('hidden');
            }
            else {
                $box.removeClass('hidden');
            }

            $content.find('div.canvas').tooltip('destroy');
            $content.html('');
            $content.append(streams[station_id].code.toString());

            if (typeof streams[station_id].back_from_inactive !== 'undefined') {
                $box.addClass('stream-progress');
                $content.append("<p>Processing</p>");
                $content.append('<div class="processing-countdown" data-countdown-until="' + streams[station_id].back_from_inactive + '"></div>');
            }
            else if (typeof streams[station_id].events[0] !== 'undefined' && typeof streams[station_id].events[0].start !== 'undefined') {
                $box.addClass('stream-error').removeClass('stream-progress');
                $content.append("<br>No Stream");
                if (typeof streams[station_id].events.nostreamsince !== 'undefined') {
                    $content.append("<p>" + streams[station_id].events.nostreamsince + "</p>");
                }
            }
            else if (streams[station_id].db_left != 0 && streams[station_id].db_right != 0) {
                $content.append("<div class='canvas'></div>");
                if (typeof streams[station_id].events.lowsince !== 'undefined') {
                    $box.addClass('stream-error').removeClass('stream-progress');
                    $content.append("<p>" + streams[station_id].events.lowsince + "</p>");
                }
                else if (typeof streams[station_id].events.highsince !== 'undefined') {
                    $box.addClass('stream-error').removeClass('stream-progress');
                    $content.append("<p>" + streams[station_id].events.highsince + "</p>");
                }
                else {
                    $box.removeClass('stream-error').removeClass('stream-progress');
                }
            }
            else {
                $box.addClass('stream-error').removeClass('stream-progress');
                $content.append("<br>No Stream");
                if (typeof streams[station_id].events.nostreamsince !== 'undefined') {
                    $content.append("<p>" + streams[station_id].events.nostreamsince + "</p>");
                }
            }
        }

        $("div.canvas").svg();
        $("a.player").addClass('play');
        $("div.processing-countdown").each(function(k, v) {
            var $this   = $(v),
                seconds = parseInt($this.data('countdown-until'), 10);
            $this.countdown({
                until: seconds,
                layout: '{mn}:{snn}'
            });
        });

        for (var station_id in streams) {
            var $actual = $("#stream_" + station_id).find('div.canvas');
            if ($actual.length === 1) {
                var title = [
                    "ACTUAL",
                    "--------------------",
                    "LEFT: " + streams[station_id].db_left + "dB",
                    "RIGHT: " + streams[station_id].db_right + "dB",
                    "",
                    "THRESHOLD",
                    "--------------------",
                    "HIGH: -" + streams[station_id].high_threshold + "dB",
                    "LOW: -" + streams[station_id].low_threshold + "dB"
                ];

                $actual.attr('title', title.join("<br>")).tooltip({ placement: 'top', html: true });
                $actual = $actual.svg('get');
                for (var j = 0; j < 2; j++) {
                    var side = j === 0 ? 'db_left' : 'db_right';

                    var width_green  = streams[station_id][side] >= -25 ? 65 : Math.max(90 - streams[station_id][side] * (-1), 0),
                        width_yellow = streams[station_id][side] >= -11 ? 13 : (24 - streams[station_id][side] * (-1)),
                        width_red    = streams[station_id][side] >= 0   ? 10 : (10 - streams[station_id][side] * (-1));

                    if (width_green > 0) {
                        $actual.rect(2, j * 13 + 2, width_green, 11, { fill : app.vu.colors.green.active });
                    }
                    if (width_yellow > 0) {
                        $actual.rect(67, j * 13 + 2, width_yellow, 11, { fill : app.vu.colors.yellow.active });
                    }
                    if (width_red > 0) {
                        $actual.rect(80, j * 13 + 2, width_red, 11, { fill : app.vu.colors.red.active });
                    }
                }
            }
        }

        // remove turned off streams
        $boxes.each(function(i, box) {
            if ($.inArray(box.dataset.streamId, box_ids) === -1) {
                box.parentNode.removeChild(box);
            }
        });

        refreshTimeout = setTimeout(getStreamInfo, app.dashboardRefreshTimeout);
    });
}

function getValidationRules() {
    return {
        focusCleanup: false,

        wrapper: 'div',
        errorElement: 'span',

        highlight: function(element) {
            $(element).parents('.form-group').removeClass ('has-success success').addClass('has-error error');
        },
        success: function(element) {
            $(element).parents('.form-group').removeClass ('has-error error').addClass('has-success success');
            $(element).parents('.form-group:not(:has(.clean))').find ('div:last').before ('<div class="clean"></div>');
        }
    };
}

})(jQuery, document, window);
